import * as React from "react"
export const Svg_075 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M10.795 42.175c-4.13 0-7.49 3.36-7.49 7.49v1.383h52.39v-1.383c0-4.13-3.36-7.49-7.49-7.49h-37.41Z"
    />
    <path fill="url(#b)" d="M6.762 54.505h45.476V59H6.762v-4.495Z" />
    <path fill="url(#c)" d="M22.691 26.822h13.618v3.457H22.691v-3.457Z" />
    <path
      fill="url(#d)"
      d="M36.535 33.736h-14.07c-.764 2.865-3.382 4.982-6.484 4.982h27.038c-3.102 0-5.72-2.117-6.484-4.982Z"
    />
    <path
      fill="url(#e)"
      d="M36.309 18.897a10.681 10.681 0 0 0 3.867-8.221c0-2.9-1.142-5.612-3.217-7.638A10.606 10.606 0 0 0 29.244.003c-2.683.063-5.254 1.19-7.239 3.174-1.985 1.984-3.113 4.554-3.178 7.237a10.651 10.651 0 0 0 3.864 8.483v4.468h13.618v-4.468Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={15.42}
        x2={16.396}
        y1={43.506}
        y2={52.83}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={17.278}
        x2={17.569}
        y1={55.18}
        y2={59.936}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={25.84}
        x2={26.402}
        y1={27.34}
        y2={30.925}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={22.233}
        x2={22.828}
        y1={34.483}
        y2={39.707}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={23.762}
        x2={35.278}
        y1={3.505}
        y2={20.537}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)